(() => {
  if (window.hpCartFeedbackInstalled) return;
  window.hpCartFeedbackInstalled = true;

  const selector = 'product-form[data-hp-cart-feedback]';
  const states = new WeakMap();
  let candidate = null;

  const attach = (element) => {
    if (states.has(element)) return states.get(element);
    const form = element.querySelector('form[data-type="add-to-cart-form"]');
    const button = form?.querySelector('button[name="add"]');
    const spinner = button?.querySelector('.loading__spinner');
    const status = element.querySelector('[data-hp-cart-status]');
    if (!form || !button || !spinner || !status) return null;

    const state = { element, form, button, spinner, status, phase: 'idle' };
    states.set(element, state);

    const clearStatus = () => {
      button.removeAttribute('aria-busy');
      status.textContent = '';
      status.hidden = true;
    };

    element.addEventListener('hp:cart-request-start', () => {
      state.phase = 'submitting';
      button.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = element.dataset.hpCartAdding;
    });

    element.addEventListener('hp:cart-request-settled', () => {
      state.phase = 'idle';
      clearStatus();
    });

    const observer = new MutationObserver(() => {
      if (candidate === state && !button.disabled) candidate = null;
      if (state.phase !== 'preparing' || button.disabled) return;
      state.phase = 'idle';
      button.classList.remove('loading');
      spinner.classList.add('hidden');
      clearStatus();
      element.handleErrorMessage?.(element.dataset.hpCartError);
    });
    observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
    return state;
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.(`${selector} button[name="add"]`);
      if (!button) return;
      const element = button.closest(selector);
      if (element.closest('quick-add-modal')) return;
      const state = attach(element);
      if (state?.phase === 'submitting') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (state && state.phase === 'idle' && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        candidate = state;
      }
    },
    true
  );

  document.addEventListener('teeinblue-event-before-customization-created', () => {
    const state = candidate;
    candidate = null;
    if (!state || !state.element.isConnected || !state.button.disabled || state.phase !== 'idle') return;
    const product = state.element.closest('product-info') || state.element;
    if (!product.querySelector('#teeFormInputs')) return;
    state.phase = 'preparing';
    state.element.handleErrorMessage?.();
    state.button.setAttribute('aria-busy', 'true');
    state.button.classList.add('loading');
    state.spinner.classList.remove('hidden');
    state.status.hidden = false;
    state.status.textContent = state.element.dataset.hpCartPreparing;
  });

  const initialize = () => document.querySelectorAll(selector).forEach(attach);
  initialize();
  document.addEventListener('teeinblue-event-component-injected', initialize);
})();
